import { Pipe, PipeTransform } from '@angular/core';

import { ContractStatus } from '@gi/enums/contract-status.enum';
import { Contract } from '@gi/models/contract';

@Pipe({
  name: 'createProspectCompanyTooltip',
  standalone: true
})
export class CreateProspectCompanyTooltipPipe implements PipeTransform {
  transform(prospectContracts: Contract[]): string {
    if (!prospectContracts?.length) {
      return 'Veuillez ajouter un contrat pour pouvoir créer le dossier client';
    }

    if (prospectContracts?.some((contract: Contract) => contract.status === ContractStatus.sent)) {
      return `Création de dossier inaccessible, un contrat du prospect est dans l'état "Envoyé"`;
    }

    return 'Créer le dossier client';
  }
}
